import store from "../../../stores";
import httpAxios from "@/axios";
import $i18n from "@/i18n";
const uuidv4 = require("uuid/v4");

const Popup = (Params) => {
  let params = Params;
  if (typeof Params === "string") {
    params = {
      type: "info",
      text: Params,
    };
  }

  let popup = {
    ...params,
    id: uuidv4(),
    type: params.type || "info",
    autohide: params.autohide || false,
  };
  return store.dispatch("popup/addPopup", popup, { root: true });
};

const ErrorPopup = (Err, Errors, Msg) => {
  let errorMsg = Msg || $i18n.t("general.errors.server_communication");
  if (Err.response && Err.response.data && Err.response.data.data) {
    errorMsg = Err.response.data.data.message;
  }

  Popup({
    title: $i18n.t("general.error"),
    text: errorMsg,
    type: "alert",
    errors: Array.isArray(Errors) && Errors.length > 0 ? Errors : null,
    autohide: 3000,
  });
};

export { Popup, ErrorPopup, httpAxios };
